import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

export default function ServiceUnavailableModal({ isOpen, onClose }) {
  const { t } = useTranslation("verify");

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
                <button
                  type="button"
                  className="absolute right-3 top-1 text-2xl text-gray-400 hover:text-gray-600 focus:outline-none"
                  onClick={onClose}
                >
                  <span className="sr-only">{t("close")}</span>
                  &times;
                </button>
                <Dialog.Title
                  as="h3"
                  className="flex w-full flex-col items-center gap-3 text-lg font-bold leading-6 text-[#D92D20]"
                >
                  <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
                    <AlertTriangle className="h-8 w-8 text-[#D92D20]" />
                  </div>
                  <div>{t("service_unavailable_title")}</div>
                </Dialog.Title>
                <div className="mt-3">
                  <p className="text-md text-center font-medium text-gray-700">
                    {t("service_unavailable_message")}
                  </p>
                </div>
                <div className="mt-5">
                  <button
                    type="button"
                    className="rounded-lg bg-cfButton px-[2rem] py-2 text-sm font-semibold text-white"
                    onClick={onClose}
                  >
                    {t("close")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
